export default __webpack_public_path__ + "static/media/account-background.31e4088a.jpg";